export default {
  UPDATE_PLATFORM_NAME: state => (state.specificManager = process.env.MANAGERS
    .filter(e => e.url === location.host)[0] || {
      terms: process.env.DEFAULT_TERMS,
      privacy: process.env.DEFAULT_PRIVACY
    }),
  UPDATE_MENU: (state, { open }) => (state.menuOpen = open),
  TOGGLE_MENU: state => (state.menuOpen = !state.menuOpen),
  UPDATE_LANGUAGES: (state, { languages }) => (state.languages = languages),
  UPDATE_COUNTRIES: (state, { countries }) => (state.countries = countries)
}



// WEBPACK FOOTER //
// ./src/store/application/mutations.js